import { VStack, Button, Text } from '@chakra-ui/react';
import type { GoalKind, GuidedListSpec } from '../../../types/guidedList'

interface StepProps { spec: GuidedListSpec; patch: (p: Partial<GuidedListSpec>) => void }

const GOALS: { key: GoalKind; label: string; blurb: string }[] = [
  { key: 'mobilize', label: 'Mobilize the base', blurb: 'Voters who already hold your positions — your most committed supporters.' },
  { key: 'persuade', label: 'Persuade the middle', blurb: 'Softer, persuadable supporters with room to move.' },
  { key: 'both', label: 'Both', blurb: 'Anyone who leans your way.' },
]

export function GoalStep({ spec, patch }: StepProps) {
  return (
    <VStack align="stretch" gap={3}>
      <Text fontWeight="semibold">What’s the goal?</Text>
      {GOALS.map(g => (
        <Button key={g.key} variant={spec.goal === g.key ? 'solid' : 'outline'}
          colorPalette="brand" justifyContent="flex-start" height="auto" py={3} whiteSpace="normal"
          onClick={() => patch({ goal: g.key })}>
          <VStack align="flex-start" gap={0}>
            <Text fontWeight="semibold">{g.label}</Text>
            <Text fontSize="xs" opacity={0.85}>{g.blurb}</Text>
          </VStack>
        </Button>
      ))}
    </VStack>
  );
}
